export default __webpack_public_path__ + "static/media/KTM.23ed36d2.png";